import './oiLogin.css';

import axios from 'axios';
import History from '../../History';
import React, { Component } from 'react';

import OiModal from '../oiModal/oiModal';
import OiLoading from '../oiLoading/oiLoading';

class oiChoice extends Component {
    state = {
        isLoading: false,
        modalIsOpen: false,
        modal: {
            title: null,
            text: null,
            btn1: null,
            btn2: null,
            event1: null,
            event2: null
        }
    };

    componentDidMount = () => {
        let msisdn = this.getUrlVars() !== {} && this.getUrlVars().msisdn ? this.getUrlVars().msisdn : false;
        let validator = this.getUrlVars() !== {} && this.getUrlVars().validator ? this.getUrlVars().validator : false;

        if (msisdn && validator) {
            this.checkoutLogin(msisdn, validator);
        }
        else if (sessionStorage.getItem("msisdn") && sessionStorage.getItem("sessionToken")) {
            History.push(`${process.env.PUBLIC_URL}/noticias`);
        }
    }

    manageModal = () => {
        this.setState({ modalIsOpen: !this.state.modalIsOpen });
    }

    getUrlVars = () => {
        let vars = {};
        let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
            vars[key] = value;
        });

        console.log(parts);

        return vars;
    }

    redirectToCheckout = () => {
        let self = this;
        let baseUrl = 'http://api.oston.io/auth/v1/consent-page/clicnoticia/redirect';
        const config = { headers: { 'Accept': 'application/json' } };

        //API REDIRECT 
        axios.get(baseUrl, config)
            .then(response => {
                window.location = response.data.url;
            })
            .catch(error => {
                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    btnIsDisabled: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Falha no redirecionamento para a tela de adesão. Por favor, tente novamente.',
                        btn1: 'Entendi',
                        event1: self.manageModal
                    }
                });
            });
    }

    checkoutLogin = (msisdn, validator) => {
        //TODO: Add bellow the new login endpoint.

        let self = this;
        let baseUrl = 'http://api.oston.io';
        let params = { msisdn: msisdn, validator: validator };
        const config = { headers: { 'Accept': 'application/json' } };

        //API CHECKOUT LOGIN
        axios.post(baseUrl, params, config)
            .then(response => {
                sessionStorage.setItem('msisdn', msisdn);
                sessionStorage.setItem('isBundle', 'no');
                sessionStorage.setItem('sessionToken', response.data.token);
                sessionStorage.setItem('phoneNumber', self.convertMsisdnToPhoneNumber(msisdn));
            })
            .catch(error => {
                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    btnIsDisabled: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Falha ao efetuar o login. Por favor, tente novamente.',
                        btn1: 'Entendi',
                        event1: self.manageModal
                    }
                });
            });
    }

    convertMsisdnToPhoneNumber = (msisdn) => {
        let auxPhone = '';
        let formatedPhone = '';

        if (msisdn) {
            auxPhone = msisdn.slice(2);
            auxPhone = auxPhone.split('');

            if (auxPhone.length === 10) {
                formatedPhone = (
                    "(" + auxPhone[0] + auxPhone[1] + ") " +
                    auxPhone[2] + auxPhone[3] + auxPhone[4] + auxPhone[5] +
                    "-" + auxPhone[6] + auxPhone[7] + auxPhone[8] + auxPhone[9]
                );
            }
            else if (auxPhone.length === 11) {
                formatedPhone = (
                    "(" + auxPhone[0] + auxPhone[1] + ") " +
                    auxPhone[2] + auxPhone[3] + auxPhone[4] + auxPhone[5] +
                    auxPhone[6] + "-" + auxPhone[7] + auxPhone[8] + auxPhone[9] + auxPhone[10]
                );
            }
            else {
                formatedPhone = "Telefone Inválido";
            }
        }

        return formatedPhone;
    }

    render = () => {
        return (
            <div id="oi-login">
                {this.state.isLoading ? <OiLoading /> : ''}
                {this.state.modalIsOpen ? <OiModal modal={this.state.modal} /> : ''}

                <div id="oi-choice-text-box">
                    <img id="oi-choice-back-image" src={`${process.env.PUBLIC_URL}` + "/imgs/banner-login.jpg"} alt="Banner Login" />

                    <img className="login__info__logo-title" src={`${process.env.PUBLIC_URL + "/imgs/logo-oi-clic-white.png"}`} alt="Logo Full" />

                    <div className="choice__content">
                        <p onClick={() => {
                            History.push(`${process.env.PUBLIC_URL}/login`);
                        }}>
                            Já sou usuário
                        </p>

                        <p onClick={() => {
                            this.redirectToCheckout();
                        }}>
                            Não sou usuário
                        </p>
                    </div>

                </div>
            </div>
        );
    }
}

export default oiChoice;


// WEBPACK FOOTER //
// ./src/components/oiLogin/oiChoice.js